import { lazy, Suspense } from 'react'

import type { Network } from '@bettermode/common/gql/generated'
import { AnalyticsSectionTitle } from '@tribeplatform/react-components/Analytics/components'
import { useMemberSegment } from '@tribeplatform/react-components/Analytics/hooks'
import { TimeFrame } from '@tribeplatform/react-components/Analytics/types'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { Container, GridList } from '@tribeplatform/react-ui-kit/Layout'

const NewMessagesArea = lazy(
  () => import('../LoadableAnalytics/NewMessagesArea.js'),
)
const TopMessageSenders = lazy(
  () => import('../LoadableAnalytics/TopMessageSenders.js'),
)

interface Props {
  networkId: Network['id']
  timeFrame: TimeFrame
  TimeFrameSelect: () => JSX.Element
}

export const MessagesAnalytics = ({
  networkId,
  timeFrame,
  TimeFrameSelect,
}: Props) => {
  const { $t } = useI18n()
  const { memberSegment, MemberSegmentSelect } = useMemberSegment()

  return (
    <Container size="lg">
      <GridList columns={3}>
        <div className="col-span-full flex justify-between web:flex-col web:md:flex-row p-1">
          <AnalyticsSectionTitle
            title={$t({
              defaultMessage: 'Messages',
              id: 'Generics.Messages',
            })}
          />
          <div className="flex gap-2">
            <MemberSegmentSelect />
            <TimeFrameSelect />
          </div>
        </div>
        <Suspense fallback={<></>}>
          <NewMessagesArea
            scope="network"
            id={networkId}
            timeFrame={timeFrame}
            segment={memberSegment}
            className="col-span-full"
          />
          <TopMessageSenders
            timeFrame={timeFrame}
            segment={memberSegment}
            networkId={networkId}
            className="col-span-full"
          />
        </Suspense>
      </GridList>
    </Container>
  )
}
